export const optionStyle = {
    active: 'text-icoBlue bg-icoBlue-100 dark:bg-icoBlue/20',
    disabled:
        'bg-icoGray-300 dark:bg-white/5 text-icoGray-400 dark:text-icoDarkMode-wolf !cursor-not-allowed'
} as const;
